var container;
var rotationButton, pauseContainer, resumeContainer;
var previousButton, nextButton;
var slidesContainer, slides;
var allnteractiveElements;
var slideDots, slideDotButtons;
var allInteractiveElements;
var isPaused = false;
var interval = 10000;
var activeSlideIndex = 0;

window.addEventListener('DOMContentLoaded', function (e) {
  container = document.querySelector('.c-ada-carousel');

    if (container != null) {

        // Get DOM elements for controls (previous, next, pause/resume buttons)
        rotationButton = document.querySelector('.controls .rotation-button');
        pauseContainer = document.querySelector('.controls .rotation-button .pause-container');
        resumeContainer = document.querySelector('.controls .rotation-button .resume-container');
        previousButton = document.querySelector('.controls .previous-button');
        nextButton = document.querySelector('.controls .next-button');

        // Get DOM elements for all slides
        slidesContainer = document.querySelector('.slides');
        slides = document.querySelectorAll('.slides .slide');

        // Get DOM elements for all interactive elements in all slides
        allInteractiveElements = document.querySelectorAll('.slides a, .slides button');

        // Get DOM elements for the slide dots
        slideDots = document.querySelectorAll('.navigation .slide-dot');
        slideDotButtons = document.querySelectorAll('.navigation .slide-dot .slide-dot-button');

        // Toggle pause when pause/play button is clicked
        rotationButton.addEventListener('click', togglePause);

        // Pause transitions and move to previous slide when previous button clicked
        previousButton.addEventListener('click', function (e) {
          disableRotation();
          previousSlide();
        });

        // Pause transitions and move to next slide when next button clicked
        nextButton.addEventListener('click', function (e) {
          disableRotation();
          nextSlide();
        });

        // Jump to specific slides when slide dots are clicked
        slideDotButtons.forEach(function (slideDotButton) {
          slideDotButton.addEventListener('click', function (e) {
            disableRotation();
            var nextSlideIndex = Array.prototype.slice.call(slideDotButtons).indexOf(slideDotButton);
            goToSlide(nextSlideIndex);
          });
        });

        // Automatically advance slides
        // NOTE: setInterval doesn't behave consistently across browsers, but simplifies the code sample for illustration purposes.
        setInterval(autoAdvance, interval);

        // Make sure all non-visible slides are properly hidden from keyboard and screen reader users
        hideNonVisibleSlides();
    }
});


/**
  Pause/unpause transitions
*/
function togglePause() {
    if (!isPaused) {
        disableRotation();
    } else {
        enableRotation();
    }
}

function disableRotation() {
    pauseContainer.classList.remove('is-visible');
    resumeContainer.classList.add('is-visible');
    isPaused = true;
}

function enableRotation() {
    pauseContainer.classList.add('is-visible');
    resumeContainer.classList.remove('is-visible');
    isPaused = false;
}


/**
  Previous/next slide
*/
function previousSlide() {
    if (activeSlideIndex > 0) {
        goToSlide(activeSlideIndex - 1);
    } else {
        goToSlide(slides.length - 1);
    }
}

function nextSlide() {
    if (activeSlideIndex < slides.length - 1) {
        goToSlide(activeSlideIndex + 1);
    } else {
        goToSlide(0);
    }
}


/**
  Move to a specific slide
*/
function goToSlide(nextSlideIndex) {
    var slideWidth = container.getBoundingClientRect().width;

    // Smoothly scroll to the requested slide using jQuery
    $(slidesContainer).animate({
        scrollLeft: slideWidth * nextSlideIndex
    }, {
        duration: 500,
        start: function () {
            // Make all slides visible during slide transition animation
            slides.forEach(function (slide) {
                slide.removeAttribute('aria-hidden');
            });

            // Move the `aria-current="true"` to the next slide's dot before animation starts for a "snappier" feel
            slideDotButtons.forEach(function (button) {
                button.removeAttribute('aria-current');
            });

            slideDotButtons[nextSlideIndex].setAttribute('aria-current', true);
        },
        complete: function () {
            // Hide all the non-visible slides from all users
            hideNonVisibleSlides();
        }
    });

    activeSlideIndex = nextSlideIndex;
}


/**
  Automatically move to the next slide, if not paused
*/
function autoAdvance() {
    if (!isPaused) {
        nextSlide();
    }
}


/**
*/
function hideNonVisibleSlides() {
    // Hide all slides from screen reader and keyboard users
    slides.forEach(function (slide) {
        slide.setAttribute('aria-hidden', true);
    });

    // Make sure that no interactive elements of any slide is focusable
    allInteractiveElements.forEach(function (element) {
        element.setAttribute('tabindex', -1);
    })

    // Make the current slide visible to screen readers
    slides[activeSlideIndex].removeAttribute('aria-hidden');

    // Make sure all interactive elements of the active slide are focusable
    var activeSlideInteractiveElements = slides[activeSlideIndex].querySelectorAll('a, button');

    activeSlideInteractiveElements.forEach(function (element) {
        element.removeAttribute('tabindex');
    });
}
